import { render, staticRenderFns } from "./productSales.vue?vue&type=template&id=0bf2164b&scoped=true"
import script from "./productSales.vue?vue&type=script&lang=js"
export * from "./productSales.vue?vue&type=script&lang=js"
import style0 from "./productSales.vue?vue&type=style&index=0&id=0bf2164b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2164b",
  null
  
)

export default component.exports